export default __webpack_public_path__ + "static/media/ecr-long.2310918d.png";